const style = (theme) => ({
  pretitle: {
    extend: theme.typography.pretit,
    marginBottom: 50,
    [theme.mq.md]: {
      marginBottom: 20,
    },
  },
  title: {
    maxWidth: '47%',
    margin: '0 auto',
    textAlign: 'center',
    position: 'relative',
    zIndex: 1,
    marginBottom: 100,
    '& h1': {
      textAlign: 'center',
    },
    [theme.mq.sm]: {
      marginBottom: 50,
      maxWidth: 'none',
      '& h1': {
        fontSize: '30px !important',
        maxWidth: 'none',
        padding: '0 20px',
      },
    },
  },
  rootDark: {
    '& $pretitle': {
      color: theme.colors[1],
    },
    '& $title': {
      '& h1': {
        color: theme.colors[1],
      },
    },
  },
})

export default style
